import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 20px;

  @media (min-width: 426px) {
    flex-direction: row;
    padding: 30px;
  }
`;

export const Plan = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex: 1;
  align-items: center;
  border-radius: 10px;
  & > div {
    width: 100%;
    text-align: center;
    padding: 20px;
    & > * {
      margin-bottom: 30px;
    }
    & h2 {
      text-transform: uppercase;
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 30px;
    }
    & li {
      font-size: 14px;
      list-style: none;
    }
  }
  @media (min-width: 426px) {
    width: auto;
  }
`;

export const Free = styled.div`
  font-size: 26px;
  color: #2d7fad;
  font-weight: bold;
`;

export const Price = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  & .price small {
    font-size: 24px;
    font-weight: bold;
  }
  & .price {
    font-size: 32px;
    color: #2d7fad;
    font-weight: bold;
  }
`;
